import AddressDisplay from 'src/components/Review/AddressDisplay';
import TextDisplay from 'src/components/Review/TextDisplay';

/**

PropertyOwnerInfo component displays the property owner's information.
@component
@example
const info = {
name: 'John Smith',
email: 'john@smith.com',
primaryPhone: '123-456-7890',
secondaryPhone: '098-765-4321',
address: {
street: '123 Main St',
city: 'New York',
state: 'NY',
zip: '10001',
},
}
return (
<PropertyOwnerInfo info={info} />
)
*/
export default function PropertyOwnerInfo({ info, className = '' }) {
  const fields = [
    { field: 'Name', value: info.name },
    { field: 'Email', value: info.email },
    { field: 'Primary Phone', value: info.primaryPhone },
    { field: 'Secondary Phone', value: info.secondaryPhone },
  ];

  return (
    <div className={`flex flex-wrap ${className} gap-4`}>
      {fields.map(({ field, value }, index) => (
        <TextDisplay key={index} className="w-full" field={field} value={value} />
      ))}
      <AddressDisplay address={info.address} />
    </div>
  );
}
